import Vue from 'vue'
import store from '../store'

Vue.directive('el-select-loadmore', {
  bind (el, binding) {
    const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
    SELECTWRAP_DOM.addEventListener('scroll', function () {
      const CONDITION = this.scrollHeight - this.scrollTop <= this.clientHeight;
      if (CONDITION) {
        binding.value()
      }
    })
  }
})

Vue.directive('loadmore', {
  bind(el, binding) {
    const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
    if (!SELECTWRAP_DOM) return;

    SELECTWRAP_DOM.addEventListener('scroll', function() {
      // 距底部距离
      const distance = this.scrollHeight - this.scrollTop - this.clientHeight;
      // 留 2px 容错，解决浮点数精度问题
      if (distance <= 2) {
        binding.value();
      }
    });
  }
})

// 自定义右击菜单指令
Vue.directive('rightClick', {
  bind: function (el, binding) {
    el.oncontextmenu = function(e) {
      const textArray = binding.value.rightMenuObj.text;
      const handlerObj = binding.value.rightMenuObj.handler;
      const url = binding.value.url; // 要跳转的页面
      // 事件处理数组
      const handlerArray = [];
      // 处理好的右键菜单
      const menuList = [];
      // 将事件处理函数放入数组中
      for (const key in handlerObj) {
        handlerArray.push(handlerObj[key]);
      }
      // 追加右键菜单数据
      for (let i = 0; i < textArray.length; i++) {
        // 右键菜单对象, 添加名称
        const menuObj = {
          text: textArray[i],
          handler: handlerArray[i],
          id: i + 1,
          url // 将页面地址传过去
        };
        menuList.push(menuObj);
      }
      // 鼠标点的坐标
      const oX = e.clientX + 100 - 210 > 0 ? e.clientX - 111 : e.clientX + 1;
      const oY = e.clientY;
      // 右键菜单出现后的位置
      store.commit("updateRightMenuStatus", {
        status: "block",
        left: oX + "px",
        top: oY + "px",
        list: menuList
      });
      return false;
    };
  }
})



// WEBPACK FOOTER //
// ./src/utils/directive.js